import React from 'react';

import { RequiredFlag } from '../required-flag';
import usePhoneInput from './phone-input.controller';

const ID = 'phone-input';
export interface PhoneInputProps {
    required?: boolean;
    valid?: boolean;
    isValidCallback?: (valid: boolean) => void;
    onChange?: (value: string) => void;
    onFocusChange?: () => void;
    value?: string;
    errorMessage?: React.ReactNode;
    label?: React.ReactNode;
    helpMessage?: React.ReactNode;
    submitted?: boolean;
    id?: string;

    className?: string;
}

export const PhoneInput = (props: PhoneInputProps) => {
    const viewProps = usePhoneInput(props);

    return (
        <div
            id={ID}
            className='inline-flex w-full flex-col items-start justify-start gap-1'>
            {props.label && (
                <div className='mb-0! flex w-full flex-col'>
                    <div className='inline-flex items-center gap-1'>
                        <span className='text-foreground-default text-sm font-medium'>{props.label ?? 'Phone number'}</span>
                        <RequiredFlag required={props.required} />
                    </div>
                    {props.helpMessage && <small className='form-text text-muted'>{props.helpMessage}</small>}
                </div>
            )}

            <div className={`form-group w-full ${props.className ?? ''}`}>
                <input
                    className={`${viewProps.inputClass} w-full`}
                    id={props.id ? props.id : 'PhonenumberInput'}
                    data-testid='PhonenumberInput'
                    value={props.value}
                    type='tel'
                    placeholder='ex. +32123456789'
                    onFocus={() => {
                        viewProps.changeTouched(true);
                        props.onFocusChange && props.onFocusChange();
                    }}
                    required={props.required}
                    onChange={(event) => {
                        if (props.onChange && viewProps.allowedInput(event.target.value)) props.onChange(event.target.value);
                        viewProps.isValid();
                    }}
                />
                {viewProps.valid === false && props.value && viewProps.touched === true && (
                    <div className='flex w-full'>
                        <small className='text-status-danger flex w-full text-xs'>
                            {props.errorMessage ? props.errorMessage : 'Please enter a valid phone number.'}
                        </small>
                    </div>
                )}
            </div>
        </div>
    );
};
